export class ComplainsModel{
thcode = 0 ;
thname = '' ;
compcode = '' ;
userid = '' ;
modifieddate = '2022-01-01' ;
}
